var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryLowStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF5E58"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_24492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 6.75H6.74967C7.2359 6.75 7.70222 6.94315 8.04604 7.28697C8.38985 7.63079 8.58301 8.0971 8.58301 8.58333V17.75C8.58301 18.2362 8.77616 18.7025 9.11998 19.0464C9.4638 19.3902 9.93011 19.5833 10.4163 19.5833H24.1663",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12.25C12.25 11.5207 12.5397 10.8212 13.0555 10.3055C13.5712 9.78973 14.2707 9.5 15 9.5H18.6667C19.396 9.5 20.0955 9.78973 20.6112 10.3055C21.1269 10.8212 21.4167 11.5207 21.4167 12.25V14.0833C21.4167 14.8127 21.1269 15.5122 20.6112 16.0279C20.0955 16.5436 19.396 16.8333 18.6667 16.8333H15C14.2707 16.8333 13.5712 16.5436 13.0555 16.0279C12.5397 15.5122 12.25 14.8127 12.25 14.0833V12.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.417 21.4163C10.417 21.9026 10.6101 22.3689 10.954 22.7127C11.2978 23.0565 11.7641 23.2497 12.2503 23.2497C12.7366 23.2497 13.2029 23.0565 13.5467 22.7127C13.8905 22.3689 14.0837 21.9026 14.0837 21.4163C14.0837 20.9301 13.8905 20.4638 13.5467 20.12C13.2029 19.7762 12.7366 19.583 12.2503 19.583C11.7641 19.583 11.2978 19.7762 10.954 20.12C10.6101 20.4638 10.417 20.9301 10.417 21.4163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 21.4163C18.667 21.9026 18.8601 22.3689 19.204 22.7127C19.5478 23.0565 20.0141 23.2497 20.5003 23.2497C20.9866 23.2497 21.4529 23.0565 21.7967 22.7127C22.1405 22.3689 22.3337 21.9026 22.3337 21.4163C22.3337 20.9301 22.1405 20.4638 21.7967 20.12C21.4529 19.7762 20.9866 19.583 20.5003 19.583C20.0141 19.583 19.5478 19.7762 19.204 20.12C18.8601 20.4638 18.667 20.9301 18.667 21.4163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_24492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryLowStock);
export default __webpack_public_path__ + "static/media/InventoryLowStock.241a78cbbfafd2881c72d9a98848fa3f.svg";
export { ForwardRef as ReactComponent };